<template>
  <div class="home-container">
    <div class="level-one-wrapper">
      <div class="search-result-wrapper">
        <div class="search-indicator">
          <div>
            <span>Hasil Pencarian: </span><span class="text-bold"></span>
          </div>
          <div class="btn-top-wrapper">
            <div>
              <button class="btn-req-vendor-baru" @click="openReqVendor">
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6.75008 9.49284H4.33341C3.8667 9.49284 3.63335 9.49284 3.45509 9.58367C3.29829 9.66356 3.1708 9.79104 3.09091 9.94785C3.00008 10.1261 3.00008 10.3595 3.00008 10.8262V17.8262M14.2501 9.49284H16.6667C17.1335 9.49284 17.3668 9.49284 17.5451 9.58367C17.7019 9.66356 17.8294 9.79104 17.9093 9.94785C18.0001 10.1261 18.0001 10.3595 18.0001 10.8262V17.8262M14.2501 17.8262V5.49284C14.2501 4.55942 14.2501 4.09271 14.0684 3.73619C13.9086 3.42258 13.6537 3.16762 13.3401 3.00783C12.9835 2.82617 12.5168 2.82617 11.5834 2.82617H9.41675C8.48333 2.82617 8.01662 2.82617 7.6601 3.00783C7.34649 3.16762 7.09153 3.42258 6.93174 3.73619C6.75008 4.09271 6.75008 4.55942 6.75008 5.49284V17.8262M18.8334 17.8262H2.16675M9.66675 6.15951H11.3334M9.66675 9.49284H11.3334M9.66675 12.8262H11.3334"
                    stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

                Request Vendor Baru
              </button>
            </div>
            <div class="sort-dropdown-container">
              <div class="sort-wrapper" @click="toogleSort">
                <i class="fas fa-sort-amount-down"></i>
                <span class="text-bold">Urutkan:</span>
                <span>{{ namingOrder(queryOrder) }}</span>
                <span><i class="fas fa-caret-down"></i></span>
              </div>
              <div class="sort-list" v-if="sortDropdownView">
                <div class="cursor-pointer hover-red" @click="sortBy('total_po')">
                  PO Terbanyak
                </div>
                <div class="cursor-pointer hover-red" @click="sortBy('csi_score_avg')">
                  Kinerja PO Terbaik
                </div>
                <div class="cursor-pointer hover-red" @click="sortBy('grade')">
                  Kinerja Kontrak Terbaik
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="search-result-filter" v-show="this.$store.state.searchStore.choosedKbli.length > 0">
          <div class="search-result-filter-wrapper">
            <ResultBar :data="this.$store.state.searchStore.choosedKbli" :desc="'desc'" :onClick="id => kbliRemove(id)" />
          </div>
        </div>
      </div>
      <div class="level1-section-container">
        <div class="level1-section-filter">
          <div class="level1-section-filter__header text-bold">
            Filter
          </div>
          <div class="level1-section-filter__content">
            <InputIcons :title="'Lokasi'" :placeholder="'Tulis Kota / Provinsi / Negara'" :model="location"
              v-model="location" />
            <FilterSio :topClass="'mb16 mt16'" />
            <FilterPertambangan :topClass="'mb16 mt8'" />
            <FilterK3l :topClass="'mb16 mt8'" />
            <FilterKplh :topClass="'mb16 mt8'" />

            <BtnIcons :path="'icon-search.png'" :title="'Tampilkan Filter'" :onClick="runSearch" />
          </div>
        </div>

        <div class="level1-section" v-if="vendorList.length > 0">
          <div class="level1-section-wrapper" v-for="vendor in vendorList">
            <CompanyCard :classCompany="'card-company'" :onClick="vendor => openModal(vendor)" :vendor="vendor" />
          </div>
        </div>

        <div class="mobile-filter" v-if="mobileFilter">
          <div class="w-90 flex-row justify-between items-center">
            <div class="level1-section-filter__header text-bold">
              Filter
            </div>
            <div @click="showMobileFilter">x</div>
          </div>
          <div class="level1-section-filter__content">
            <InputIcons :title="'Lokasi'" :placeholder="'Tulis Kota / Provinsi / Negara'" v-model="location" />
            <FilterSio :topClass="'mb16 mt16'" />
            <FilterPertambangan :topClass="'mb16 mt8'" />
            <FilterK3l :topClass="'mb16 mt8'" />
            <FilterKplh :topClass="'mb16 mt8'" />

            <BtnIcons :className="'level1-section-filter__footer'" :path="'icon-search.png'" :title="'Tampilkan Filter'"
              :onClick="runSearch" />
          </div>
        </div>

        <div class="btn-filter-mobile" @click="showMobileFilter">
          <img :src="require('~/assets/img/icons/icon-filter.png')" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    CompanyCard: () => import('@/components/Organism/CompanyCard.vue'),
    Perizinan: () =>
      import('@/components/CompanyInfo/Perizinan/KegiatanUsahaUtama.vue'),
    Informasi: () => import('@/components/CompanyInfo/Informasi'),
    LegalDocument: () => import('@/components/CompanyInfo/LegalDocument'),
    SIO: () => import('@/components/CompanyInfo/SIO'),
    K3L: () => import('@/components/CompanyInfo/K3L'),
    KPLH: () => import('@/components/CompanyInfo/KPLH'),
    InputIcons: () => import('@/components/Atoms/InputIcons'),
    FilterSio: () => import('@/components/Atoms/FilterSio'),
    FilterPertambangan: () => import('@/components/Atoms/FilterPertambangan'),
    FilterK3l: () => import('@/components/Atoms/FilterK3l'),
    FilterKplh: () => import('@/components/Atoms/FilterKplh'),
    BtnIcons: () => import('@/components/Atoms/BtnIcons'),
    ResultBar: () => import('@/components/Organism/ResultBar.vue'),
  },
  data() {
    return {
      listUsaha: [
        {
          name: 'Pertanian, Kehutanan, dan Perikanan',
          id: '1',
          sub: [
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
          ],
        },
        {
          name: 'Pertambangan dan Penggalian',
          id: '2',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Industri Pengolahan',
          id: '3',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Pengadaan Listrik, Gas, Uap/Air Panas dan Udara',
          id: '4',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Treatmen Air, Treatment Air Limbah, Treatment Udara',
          id: '5',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Konstruksi',
          id: '6',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Perdagangan Besar Dan Eceran, Reparasi dan Perbaikan',
          id: '7',
          sub: [
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
          ],
        },
        {
          name: 'Pengangkutan dan Pergudangan',
          id: '8',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Penyediaan Akomodasi dan Penyediaan Makanan dan Minuman',
          id: '9',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Informasi dan Komunikasi',
          id: '10',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Keuangan dan Asuransi',
          id: '11',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Real Estat',
          id: '12',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Profesional, Ilmiah dan Teknis',
          id: '13',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Penyewaan dan Sewa Guna Usaha dan Jasa',
          id: '14',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Administrasi Pemerintahan Pusat',
          id: '15',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Pendidikan',
          id: '16',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Kesehatan Manusia dan Aktivitas Mesin',
          id: '17',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Kesenian, Hiburan dan Rekreasi',
          id: '18',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Jasa Lainnya',
          id: '19',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name:
            'Aktivitas Rumah Tangga Sebagai Pemberi Kerja kepada masyarakat',
          id: '20',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Badan International dan Nasional',
          id: '21',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
      ],
      modalOpen: false,
      sortDropdownView: false,
      mobileFilter: false,
    }
  },
  async created() {
    const vendor = this.$get(this.$route, 'query.vendor', null)

    if (vendor) {
      console.log('query:  ', vendor)

      await this.$store.commit('level1/setData', {
        name: 'vendorId',
        value: vendor,
      })
      await this.$store.commit('level1/GET_PROFILE_DATA', {
        id: vendor,
        onSuccess: () => {
          this.$store.commit('level1/GET_INFO_DATA', 'informasi')
        },
      })
      await this.$store.commit('modalStore/openModal', {
        name: 'profile',
      })
    }
  },
  computed: {
    queryOrder() {
      return this.$store.state.level1.queryOrder
    },
    vendorList() {
      return this.$store.state.level1.vendors
    },
    vendorName: {
      get: function () {
        return this.$store.state.searchStore.vendorName
      },
      set: function (newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'vendorName',
          value: newValue,
        })
      },
    },
    location: {
      get() {
        return this.$store.state.searchStore.location
      },
      set(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'location',
          value: newValue,
        })
      },
    },
    choosedKbli: {
      get: function () {
        return this.$store.state.searchStore.choosedKbli
      },
    },
    choosedIujp: {
      get: function () {
        return this.$store.state.searchStore.choosedIujp
      },
    },
    choosedIujptl: {
      get: function () {
        return this.$store.state.searchStore.choosedIujptl
      },
    },
    choosedSbujk: {
      get: function () {
        return this.$store.state.searchStore.choosedSbujk
      },
    },
    choosedInubbm: {
      get: function () {
        return this.$store.state.searchStore.choosedInubbm
      },
    },
    choosedSiupal: {
      get: function () {
        return this.$store.state.searchStore.choosedSiupal
      },
    },
    chooseSio: {
      get: function () {
        return this.$store.state.searchStore.chooseSio
      },
    },
    chooseK3lScore() {
      return this.$store.state.searchStore.chooseK3lScore
    },
    chooseKplhScore() {
      return this.$store.state.searchStore.chooseKplhScore
    },
    chooseMine() {
      return this.$store.state.searchStore.chooseMine
    },
  },
  watch: {
    queryOrder(newValue) {
      console.log('query order value: ', newValue)
      if (this.vendorList.length > 0) {
        this.$store.commit('level1/GET_VENDOR')
      }
    },
  },
  methods: {
    isKplhExpired(data) {
      console.log('is Kplh Exp: ==', data);
      if (!data) return false;
      const today = new Date();
      const expirationDate = new Date(data);
      console.log('kplh expired date', expirationDate);
      return expirationDate < today;
    },
    isK3lExpired(data) {
      console.log('is K3l Exp: ==', data);
      if (!data) return false;
      const today = new Date();
      const expirationDate = new Date(data);
      console.log('k3l expired date', expirationDate < today);
      return expirationDate < today;
    },
    openReqVendor() {
      this.$store.commit('modalStore/setValue', {
        name: 'modalTicketNewVendor',
        value: true,
      })
    },
    showMobileFilter() {
      this.mobileFilter = !this.mobileFilter
    },
    async sortBy(value) {
      await this.$store.commit('level1/setData', {
        name: 'queryOrder',
        value: `&order_by=${value}&order_short=desc`,
      })

      this.sortDropdownView = false
    },
    toogleSort() {
      this.sortDropdownView = !this.sortDropdownView
    },
    namingOrder(value) {
      switch (value) {
        case '&order_by=total_po&order_short=desc':
          return 'PO Terbanyak'
          break
        case '&order_by=grade&order_short=desc':
          return 'Kinerja Kontrak Terbaik'
          break
        case '&order_by=csi_score_avg&order_short=desc':
          return 'Kinerja PO Terbaik'
          break

        default:
          break
      }
    },
    activeTab(value) {
      this.tabCompany = value
    },
    async openModal(vendor) {
      console.log('vendor: ', vendor)
      await this.$store.commit('level1/setData', {
        name: 'vendorId',
        value: vendor.id,
      })
      await this.$store.commit('level1/GET_PROFILE_DATA', {
        id: vendor.id,
        onSuccess: () => {
          this.$store.commit('level1/GET_INFO_DATA', 'informasi')
        },
      })
      await this.$store.commit('modalStore/openModal', {
        name: 'profile',
      })

      let vendors = await localStorage.getItem('vendors')
      if (vendors) {
        vendors = JSON.parse(vendors)
        vendors = vendors.filter(i => i.id != vendor.id)
      } else {
        vendors = []
      }

      console.log('vendors: ', vendors)
      console.log('vendor to push: ', vendor)

      vendors.unshift(vendor)
      console.log('vendor after push: ', vendors)

      if (vendors.length > 8) {
        vendors.pop()
      }
      await localStorage.setItem('vendors', JSON.stringify(vendors))
    },
    closeModal() {
      this.modalOpen = false
    },
    runFilter() {
      console.log('run filter')
    },
    async kbliRemove(id) {
      let data = this.$store.state.searchStore.choosedKbli

      let newData = data.filter(i => i.id != id)

      await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
        name: 'choosedKbli',
        value: newData,
      })

      await this.runSearch()
    },
    async runSearch() {
      console.log('run search')
      let query = {
        vendorName:
          this.vendorName && this.vendorName !== ''
            ? `&search=${this.vendorName}`
            : '',
        location: this.location != '' ? `&location=${this.location}` : '',
        status: this.chooseStatus ? `&status=${this.chooseStatus}` : '',
        negara: this.choosedCountry
          ? `&negara_id=${this.choosedCountry.id}`
          : '',
        prov: this.choosedProvince
          ? `&provinsi_id=${this.choosedProvince.id}`
          : '',
        kota: this.choosedCity ? `&kota_id=${this.choosedCity.id}` : '',
        kec: this.choosedDistric
          ? `&kecamatan_id=${this.choosedDistric.id}`
          : '',
        kel: this.choosedVillage
          ? `&kelurahan_id=${this.choosedVillage.id}`
          : '',
        tambang: this.chooseMine ? `&pertambangan_inti=${this.chooseMine}` : '',
        sio: this.chooseSio ? `&sio=${this.chooseSio}` : '',
        k3l: this.chooseK3lScore.length > 0 ? '&k3l=1' : '',
        kplh: this.chooseKplhScore.length > 0 ? '&kplh=1' : '',
        poStart: this.poStartDate ? `&po_start_date=${this.poStartDate}` : '',
        poEnd: this.poEndDate ? `&po_end_date=${this.poEndDate}` : '',
        eventStart: this.eventStartDate
          ? `&event_start_date=${this.eventStartDate}`
          : '',
        eventEnd: this.eventEndDate
          ? `&event_end_date=${this.eventEndDate}`
          : '',
        spmStart: this.spmStartDate
          ? `&spm_start_date=${this.spmStartDate}`
          : '',
        spmEnd: this.spmEndDate ? `&spm_end_date=${this.spmEndDate}` : '',
        sioStart:
          this.chooseSio == 1 && this.sioStartDate
            ? `&sio_start_date=${this.sioStartDate}`
            : '',
        sioEnd:
          this.chooseSio == 1 && this.sioEndDate
            ? `&sio_end_date=${this.sioEndDate}`
            : '',
        k3lStart:
          this.choosePraqualifikasiK3l && this.k3lStartDate
            ? `&k3l_end_date=${this.k3lStartDate}`
            : '',
        k3lEnd:
          this.choosePraqualifikasiK3l && this.k3lEndDate
            ? `&k3l_end_date=${this.k3lEndDate}`
            : '',
        kplhStart:
          this.choosePraqualifikasiKplh && this.kplhStartDate
            ? `&kplh_end_date=${this.kplhStartDate}`
            : '',
        kplhEnd:
          this.choosePraqualifikasiKplh && this.kplhEndDate
            ? `&kplh_end_date=${this.kplhEndDate}`
            : '',
        gradeStart: this.spmScoreStart
          ? `&grade_start=${this.spmScoreStart}`
          : '',
        gradeEnd: this.spmScoreEnd ? `&grade_end=${this.spmScoreEnd}` : '',
        csiStart: this.poScoreStart ? `&csi_start=${this.poScoreStart}` : '',
        csiEnd: this.poScoreEnd ? `&csi_end=${this.poScoreEnd}` : '',
        k3lScore:
          this.chooseK3lScore.length > 0
            ? this.paramsFormatter('k3l_score', this.chooseK3lScore)
            : '',
        kplhScore:
          this.chooseKplhScore.length > 0
            ? this.paramsFormatter('kplh_score', this.chooseKplhScore)
            : '',
        kbliSub:
          this.choosedKbli && this.choosedKbli.length > 0
            ? this.paramsFormatter(
              'kbli_sub',
              this.choosedKbli.map(item => {
                return item.id
              })
            )
            : '',
        iujp:
          this.choosedIujp && this.choosedIujp.length > 0
            ? this.paramsFormatter(
              'iujp',
              this.choosedIujp.map(item => {
                return item.id
              })
            )
            : '',
        iujptl:
          this.choosedIujptl && this.choosedIujptl.length > 0
            ? this.paramsFormatter(
              'iujptl',
              this.choosedIujptl.map(item => {
                return item.id
              })
            )
            : '',
        sbujk:
          this.choosedSbujk && this.choosedSbujk.length > 0
            ? this.paramsFormatter(
              'sbujk',
              this.choosedSbujk.map(item => {
                return item.id
              })
            )
            : '',
        inubbm:
          this.choosedInubbm && this.choosedInubbm.length > 0
            ? this.paramsFormatter(
              'inubbm',
              this.choosedInubbm.map(item => {
                return item.id
              })
            )
            : '',
        siupal:
          this.choosedSiupal && this.choosedSiupal.length > 0
            ? this.paramsFormatter(
              'siupal',
              this.choosedSiupal.map(item => {
                return item.id
              })
            )
            : '',
      }

      // await this.$store.commit('modalStore/SET_MODAL_LEVEL1', false)
      this.mobileFilter = false
      await this.$store.commit('level1/GET_VENDOR', { query })
      await this.$store.commit('modalStore/closeModal', {
        name: 'advanceSearch',
      })

      if (this.$route.path !== '/search-result') {
        await this.$router.push('search-result')
      }
    },
  },
}
</script>
